import React from "react"
import { Sidebar, RecentActionsIcon, WatchHistoryIcon } from "@dit/core-frontend"
import { ROUTES } from "@constants"
import { PAGE_TITLE } from "@pages/RecentWork/RecentWorkUtils"

import styles from "./WorkHistorySidebar.module.css"

const links = [
  {
    label: PAGE_TITLE.EDIT,
    link: ROUTES.RESENT_WORK,
    icon: <RecentActionsIcon size={24} color="#000" />,
  },
  {
    label: PAGE_TITLE.VIEW,
    link: ROUTES.VIEW_HISTORY,
    icon: <WatchHistoryIcon size={24} color="#000" />,
  },
]

export const WorkHistorySideBar = () => {
  return (
    <Sidebar
      headerContent={<div className={styles.header}>Моя работа</div>}
      sectionsLinkList={links}
    />
  )
}
